//export const URL = 'http://beta-fansa.es';
export const URL = 'https://fansa.es';
export const IMG = URL;

export const APIS = {
  fansa: `${URL}/api`,
  scheurich: `${URL}/api_scheurich`,
};

export let API = APIS.fansa;
export const API_SCHEURICH = APIS.scheurich;
export let BRANDCHOSEN = 'fansa';

export const colores = {
  fansa: '#6FC2B9',
  scheurich: '#D65144',
};
export function CambiarUrlApi(value) {
  BRANDCHOSEN = value;
  CambiarColoresPrincipales();
}
function ajustarColor(hex, cambio) {
  let prefijo = '';
  if (hex[0] === '#') {
    hex = hex.slice(1);
    prefijo = '#';
  }

  const num = parseInt(hex, 16);
  let r = (num >> 16) + cambio;
  let g = ((num >> 8) & 255) + cambio;
  let b = (num & 255) + cambio;

  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  const nuevoColor = (r << 16) | (g << 8) | b;
  return prefijo + nuevoColor.toString(16).padStart(6, '0');
}

export function CambiarColoresPrincipales(brand = BRANDCHOSEN) {
  const color = colores[brand];
  document.documentElement.style.setProperty('--color-first-var', color);
  document.documentElement.style.setProperty('--color-first-dark-var', ajustarColor(color, -30));
  document.documentElement.style.setProperty('--color-first-semi-light-var', ajustarColor(color, 45));
  document.documentElement.style.setProperty('--color-first-light-var', ajustarColor(color, 95));
}

export const PreChangeBrandChosen = function(brand, budgets) {
  return new Promise((resolve) => {
    if (brand !== BRANDCHOSEN && budgets.length > 0) {
      resolve(false);
    } else {
      CambiarUrlApi(brand);
      resolve(true);
    }
  });
};
